<dx-chart
    *ngIf="!!dashboardChartData"
    class="cc-white-background"
    seriesSelectionMode="single"
    [adaptiveLayout]="{ keepLabels: false }"
    [palette]="dashboardChartPalette || palette"
    [paletteExtensionMode]="paletteMode"
    [dataSource]="dashboardChartData"
    (onDrawn)="onChartDrawn($event)"
    (onPointClick)="onPointClick($event)"
    (onLegendClick)="onLegendClick($event)"
    (onArgumentAxisClick)="onAxisLabelClick($event)"
>
    <dxo-title *ngIf="!widgetId" [text]="dashboardChartTitle">
        <dxo-font [size]="14" [weight]="600"></dxo-font>
        <dxo-margin [top]="5" [bottom]="0" [left]="0" [right]="0"></dxo-margin>
    </dxo-title>
    <dxo-loading-indicator [enabled]="false"></dxo-loading-indicator>
    <dxo-legend
        horizontalAlignment="right"
        verticalAlignment="top"
        orientation="vertical"
        [columnItemSpacing]="5"
        [rowItemSpacing]="1"
    >
        <dxo-font [size]="fontSize"></dxo-font>
    </dxo-legend>
    <dxo-size [width]="width" [height]="height"></dxo-size>
    <dxo-common-series-settings argumentField="title" [type]="dashboardChartType">
        <dxo-label [visible]="dashboardChartType === 'bar'" [rotationAngle]="270"></dxo-label>
    </dxo-common-series-settings>
    <dxi-series [valueField]="openValueField" name="Open" color="#6cb9f1"></dxi-series>
    <dxi-series valueField="priority" name="Priority" color="#e47148"></dxi-series>
    <dxi-series valueField="problematic" name="Problematic" color="#c81e26"></dxi-series>
    <dxo-export [enabled]="!widgetMode" [fileName]="exportFileName()"></dxo-export>
    <dxo-argument-axis>
        <dxo-label [visible]="true" template="labelTemplate"></dxo-label>
    </dxo-argument-axis>
    <svg overflow="visible" *dxTemplate="let data of 'labelTemplate'">
        <text class="axis-template-text" [attr.title]="data.valueText" text-anchor="middle">
            {{ data.valueText }}
        </text>
    </svg>
</dx-chart>

<dx-popup
    *ngIf="!!dashboardDetails"
    [title]="popupTitle"
    [showTitle]="true"
    [resizeEnabled]="true"
    [visible]="true"
    (onShown)="repaint($event)"
    (onHidden)="cleanup()"
>
    <div *dxTemplate="let data of 'content'">
        <app-user-dashboard-details
            [selectedUser]="selectedUser"
            [selectedViewOption]="selectedViewOption"
            [filterField]="filterField"
            [dashboardDetails]="dashboardDetails"
        ></app-user-dashboard-details>
    </div>
</dx-popup>
